var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Page", [
    _c(
      "div",
      { staticClass: "resportList" },
      [
        _c("div", [
          _c("div", { staticClass: "headerTitle-top" }, [
            _c("div", { staticClass: "flex-title" }, [_vm._v("门店：")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "picker-alls", on: { click: _vm.pickerAll } },
              [
                _vm._v(_vm._s(_vm.dealerName || "全部") + "\n          "),
                _c("div", { staticClass: "triangle_border_down" })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "general-statistics flex" }, [
            _c("div", { staticClass: "flex-title" }, [_vm._v("概况统计：")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex timeList" },
              _vm._l(_vm.timeList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: item.edit == true ? "timeListActive" : "",
                    on: {
                      click: function($event) {
                        return _vm.switchDate(index)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "statisticsList" },
            _vm._l(_vm.statisticsList, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "statisticsList-item" },
                [
                  _c("div", { staticClass: "C" }, [_vm._v(_vm._s(item.name))]),
                  _vm._v(" "),
                  item.id == 0
                    ? _c("div", { staticClass: "C" }, [
                        _vm._v(
                          _vm._s(
                            item.price
                              ? _vm.$numeral(item.price).format("0,0.00")
                              : 0
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.id == 1 && index == 2
                    ? _c("div", { staticClass: "C" }, [
                        _vm._v(
                          _vm._s(
                            _vm.statisticsList[0].price == 0
                              ? "-"
                              : _vm.$numeral(item.price).format("0,0.00") + "%"
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.id == 1 && index == 3
                    ? _c("div", { staticClass: "C" }, [
                        _vm._v(
                          _vm._s(
                            _vm.dailyBasic.lastYearAmount == 0
                              ? "-"
                              : _vm.$numeral(item.price).format("0,0.00") + "%"
                          )
                        )
                      ])
                    : _vm._e()
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "statisticsList clientList" },
            _vm._l(_vm.clientList, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "statisticsList-item" },
                [
                  _c("div", { staticClass: "C" }, [_vm._v(_vm._s(item.name))]),
                  _vm._v(" "),
                  item.id == 0
                    ? _c("div", { staticClass: "C" }, [
                        _vm._v(
                          _vm._s(
                            item.price
                              ? _vm.$numeral(item.price).format("0,0.00")
                              : 0
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  item.id == 1
                    ? _c("div", { staticClass: "C" }, [
                        _vm._v(
                          _vm._s(
                            item.price
                              ? _vm.$numeral(item.price).format("0,0")
                              : 0
                          )
                        )
                      ])
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c(
          "van-tabs",
          {
            on: {
              click: function($event) {
                return _vm.tabsShow(_vm.active)
              }
            },
            model: {
              value: _vm.active,
              callback: function($$v) {
                _vm.active = $$v
              },
              expression: "active"
            }
          },
          [
            _c(
              "van-tab",
              { attrs: { title: "新客（" + _vm.totalRowA + "）" } },
              [
                _c(
                  "van-list",
                  {
                    attrs: {
                      finished: _vm.finishedA,
                      "finished-text": "没有更多了"
                    },
                    on: { load: _vm.onLoadA },
                    model: {
                      value: _vm.loadingA,
                      callback: function($$v) {
                        _vm.loadingA = $$v
                      },
                      expression: "loadingA"
                    }
                  },
                  _vm._l(_vm.listA, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "scroll-view-list-item",
                        on: {
                          click: function($event) {
                            return _vm.toClientDetail(item.AccountId)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "information-list" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("客户")
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(item.name || ""))])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("性别")
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(item.gender == "0" ? "男" : "女"))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("手机号")
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(item.mobile || ""))])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("VIP等级")
                              ]),
                              _vm._v(" "),
                              item.vip
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "VIP-starts",
                                      style: "width:" + item.vip * 0.4 + "rem"
                                    },
                                    _vm._l(item.vip, function(item, index) {
                                      return _c("img", {
                                        key: index,
                                        staticClass: "start",
                                        attrs: {
                                          src: require("@/assets/img/vipStar.png"),
                                          alt: "",
                                          srcset: ""
                                        }
                                      })
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "van-tab",
              { attrs: { title: "老客（" + _vm.totalRowB + "）" } },
              [
                _c(
                  "van-list",
                  {
                    attrs: {
                      finished: _vm.finishedB,
                      "finished-text": "没有更多了"
                    },
                    on: { load: _vm.onLoadB },
                    model: {
                      value: _vm.loadingB,
                      callback: function($$v) {
                        _vm.loadingB = $$v
                      },
                      expression: "loadingB"
                    }
                  },
                  _vm._l(_vm.listB, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "scroll-view-list-item",
                        on: {
                          click: function($event) {
                            return _vm.toClientDetail(item.AccountId)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "information-list" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("客户")
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(item.name || ""))])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("性别")
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(item.gender == "0" ? "男" : "女"))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("手机号")
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(item.mobile || ""))])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("VIP等级")
                              ]),
                              _vm._v(" "),
                              item.vip
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "VIP-starts",
                                      style: "width:" + item.vip * 0.4 + "rem"
                                    },
                                    _vm._l(item.vip, function(item, index) {
                                      return _c("img", {
                                        key: index,
                                        staticClass: "start",
                                        attrs: {
                                          src: require("@/assets/img/vipStar.png"),
                                          alt: "",
                                          srcset: ""
                                        }
                                      })
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "van-tab",
              { attrs: { title: "购买记录（" + _vm.totalRowC + "）" } },
              [
                _c(
                  "van-list",
                  {
                    attrs: {
                      finished: _vm.finishedC,
                      "finished-text": "没有更多了"
                    },
                    on: { load: _vm.onLoadC },
                    model: {
                      value: _vm.loadingC,
                      callback: function($$v) {
                        _vm.loadingC = $$v
                      },
                      expression: "loadingC"
                    }
                  },
                  _vm._l(_vm.listC, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "scroll-view-list-item" },
                      [
                        _c("div", { staticClass: "information-list" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("购买日期")
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    item.date
                                      ? item.date.replace(/-/g, "/")
                                      : ""
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("零售价")
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    item.amount
                                      ? _vm
                                          .$numeral(item.amount)
                                          .format("0,0.00")
                                      : ""
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("产品分类")
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(item.products2ndType || ""))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("未税金额")
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    item.amountBefTax
                                      ? _vm
                                          .$numeral(item.amountBefTax)
                                          .format("0,0.00")
                                      : ""
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("中文名称")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "ep" }, [
                                _vm._v(_vm._s(item.productNameCH || ""))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "information-list-item item-lists flex activeFont"
                            },
                            [
                              _c("div", { staticClass: "title-LF" }, [
                                _vm._v("购买渠道")
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(item.deptName || ""))])
                            ]
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "van-popup",
          {
            attrs: { position: "bottom", overlay: true },
            model: {
              value: _vm.show,
              callback: function($$v) {
                _vm.show = $$v
              },
              expression: "show"
            }
          },
          [
            _c("van-picker", {
              staticClass: "van-picker-li",
              attrs: {
                "show-toolbar": "",
                title: "",
                columns: _vm.columns,
                "value-key": "deptName"
              },
              on: { cancel: _vm.onCancel, confirm: _vm.onConfirm }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.active == 0,
                expression: "active==0"
              }
            ],
            staticClass: "loaded"
          },
          [
            _vm._v(
              "已加载 " +
                _vm._s(this.listA.length) +
                "/" +
                _vm._s(_vm.totalRowA)
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.active == 1,
                expression: "active==1"
              }
            ],
            staticClass: "loaded"
          },
          [
            _vm._v(
              "已加载 " +
                _vm._s(this.listB.length) +
                "/" +
                _vm._s(_vm.totalRowB)
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.active == 2,
                expression: "active==2"
              }
            ],
            staticClass: "loaded"
          },
          [
            _vm._v(
              "已加载 " +
                _vm._s(this.listC.length) +
                "/" +
                _vm._s(_vm.totalRowC)
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-273f13af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-273f13af","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/resportList.vue
// module id = null
// module chunks = 